module.exports = __webpack_public_path__ + "static/media/conditioning_protocol_comply1.03b30cbd.mp3";